import { schema } from 'normalizr';

import { processViewerIsFollowingUser, processViewerIsFollowingUserSender } from '../strategies/viewerIsFollowingUser';

export const viewerIsFollowingUserSchema = new schema.Entity(
  'viewerIsFollowingUsers',
  {},
  { processStrategy: processViewerIsFollowingUser }
);

export type ViewerIsFollowingUserEdgesSchema = typeof viewerIsFollowingUserEdgesSchema;
export const viewerIsFollowingUserEdgesSchema = [new schema.Object({ node: viewerIsFollowingUserSchema })];

export const viewerIsFollowingUserSenderSchema = new schema.Entity(
  'viewerIsFollowingUsers',
  {},
  { idAttribute: (entity) => entity.sender.id, processStrategy: processViewerIsFollowingUserSender }
);
export type ViewerIsFollowingUserSenderEdgesSchema = typeof viewerIsFollowingUserSenderEdgesSchema;
export const viewerIsFollowingUserSenderEdgesSchema = [new schema.Object({ node: viewerIsFollowingUserSenderSchema })];
